import { IsString, MaxLength } from 'class-validator';

export class CollectiveAgreementSearchDTO {

    @IsString()
    @MaxLength(50)
    name: string;

}